import { useEffect, useState, useRef } from "react";
import { io } from "socket.io-client";
import { URL } from "../store/utils";

export default function useDashboardSocket(room) {
  const [stats, setStats] = useState(null);
  const [connected, setConnected] = useState(false);
  const socketRef = useRef(null);

  useEffect(() => {
    if (!room) return;

    // Production'da web ve API aynı origin altında (nginx proxy). URL.url
    // boş gelirse io("") socket.io-client'in same-origin default'unu kullanır;
    // localhost fallback'ı asla devreye girmesin diye URL.url1'e düşmüyoruz.
    const isDev = process.env.NODE_ENV === "development";
    const baseUrl = isDev
      ? String(URL.url || URL.url1 || "").replace(/\/+$/, "")
      : (typeof window !== "undefined" ? window.location.origin : "");
    const socket = io(baseUrl, {
      path: "/socket.io",
      transports: ["websocket", "polling"],
    });

    socketRef.current = socket;

    socket.on("connect", () => {
      setConnected(true);
      socket.emit("join", room);
    });

    socket.on("disconnect", () => {
      setConnected(false);
    });

    socket.on("dashboard:stats-update", (data) => {
      setStats(data);
    });

    return () => {
      socket.emit("leave", room);
      socket.disconnect();
      socketRef.current = null;
    };
  }, [room]);

  return { stats, connected };
}
